export const FETCH_SESSIONS_LIST = 'FETCH_SESSIONS_LIST';
export const SET_SESSIONS_LIST = 'SET_SESSIONS_LIST';